<template>
  <rmp-base-modal
    v-model="isOpen"
    extra-classes="Compact"
    @base-modal:closed="handleClose"
  >
    <template #modal-header>
      <h2 class="u-text-center">
        Send Data
      </h2>
    </template>
    <template #modal-body>
      <div class="Notice Notice--warning no-margin">
        <div class="Notice-copy">
          <p>Are you sure you wish to send <strong>{{ zapierDeliveryTotal }} records </strong> to Zapier?</p>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="u-floatLeft">
        <button
          class="Button Button--green-outline"
          @click="isOpen = false"
        >
          Cancel
        </button>
      </div>
      <div class="u-floatRight">
        <button
          :class="[{'is-loading': ui.submitLoading }, 'Button Button--green']"
          @click="handleConfirmation"
        >
          Send Data
        </button>
      </div>
    </template>
  </rmp-base-modal>
</template>
<script>
import RmpBaseModal from '@rmpenterprise/base-modal';
import ModalActionsMixin from './mixins/modal-actions-mixin';

export default {
  components: { RmpBaseModal },
  mixins: [ModalActionsMixin],
  props: {
    zapierDeliveryTotal: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      ui: {
        submitLoading: false,
      },
    };
  },
  methods: {

    handleConfirmation() {
      this.ui.submitLoading = true;

      this.$emit('resend-zapier-data:confirmation');
      // this.deleteEvent(this.event.id)
      //   .then(({ data }) => {
      //     // success
      //     this.isOpen = false;
      //     this.$emit('delete-event:success');
      //     this.$bus.$emit('displayMsg', {
      //       text: data.message,
      //       type: 'success',
      //     });
      //     this.ui.submitLoading = false;
      //   })
      //   .catch(({ data }) => {
      //     this.ui.submitLoading = false;
      //     this.$bus.$emit('global-dismiss-modal'); // Dismiss modal
      //     this.$bus.$emit('displayMsg', {
      //       text: data.message,
      //       type: 'warning',
      //     });
      //   });
    },
    handleClose() {
      this.ui.submitLoading = false;
    },
  },
};
</script>
<style lang="less" scoped>

p, ul, li {
  color: #a94442;
}

  .Notice {
    margin-bottom: 0;

}
</style>
